module.exports = __webpack_public_path__ + "img/color-5.f5c8937.png";